import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M666.286,1242.8 C578.118,1163.01 522.636,1047.74 522.636,919.767 L522.636,435.679 C522.636,195.475 718.111,0 958.315,0 C1135.27,0 1287.96,106.09 1356.09,257.997 L1536.8,0 L1629.18,64.6686 L331.381,1917.48 L239,1852.81 L544.289,1416.97 C412.414,1301.53 329,1132.02 329,943.408 L329,709.98 L425.818,709.98 L425.818,943.408 C425.818,1099.22 493.138,1239.65 600.211,1337.13 L666.286,1242.8 Z M795.32,1450.38 L737.604,1532.78 C791.898,1553.18 849.733,1566.28 909.908,1570.88 L909.908,1823.18 L667.861,1823.18 L667.861,1920 L1248.77,1920 L1248.77,1823.18 L1006.726,1823.18 L1006.726,1570.88 C1331.19,1546.08 1587.63,1274.12 1587.63,943.408 L1587.63,709.98 L1490.81,709.98 L1490.81,943.408 C1490.81,1236.96 1251.87,1475.9 958.315,1475.9 C901.491,1475.9 846.714,1466.95 795.32,1450.38 Z M1393.99,595.685 L868.36,1346.11 C897.396,1352.23 927.487,1355.45 958.315,1355.45 C1198.52,1355.45 1393.99,1159.97 1393.99,919.767 L1393.99,595.685 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMicOffSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMicOffSolid, _Component);

  var _super = _createSuper(IconMicOffSolid);

  function IconMicOffSolid() {
    _classCallCheck(this, IconMicOffSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMicOffSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMicOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMicOffSolid.displayName = "IconMicOffSolid";
  return IconMicOffSolid;
}(Component);

IconMicOffSolid.glyphName = 'mic-off';
IconMicOffSolid.variant = 'Solid';
IconMicOffSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMicOffSolid;
export { IconMicOffSolid };